<template>
	<div>
		<!-- Discount Section -->
		<section class="container-fluid special-offer" v-if="promo">
			<div class="container p-0 px-sm-4">
				<div
					class="row spo-container align-items-md-center flex-md-wrap flex-column flex-md-row"
				>
					<div class="col-auto d-none d-md-inline">
						<img class="" src="@/assets/img/v1/percent-icon.png" />
					</div>
					<div
						class="col d-flex align-items-center limited-offer-text"
					>
						<p>
							<img
								class="float-left d-md-none"
								src="@/assets/img/v1/percent-icon.png"
							/>
							<b>LIMITED TIME OFFER:</b> Get
							{{ promo.discount_percent }}% <u>OFF</u> Your OHO
							Pro&trade;! Normally
							<del
								class="old-price"
								v-if="promo.discount_percent"
								>{{
									promo.prices.priceEachOriginalCurrency.full
								}}</del
							>, Now just
							<span class="new-price">{{
								promo.prices.priceEachCurrency.full
							}}</span
							><span> /watch</span>
							<b> + Free Shipping!</b>
						</p>
					</div>
					<div
						class="col-auto my-2 d-none d-md-block"
						v-if="promo.discount_percent"
					>
						<div class="discount mx-auto">
							<div
								class="row align-items-center m-0 text-uppercase"
							>
								<div class="col-auto pl-0 pr-3">
									<span class="discount-percent-text"
										>{{ promo.discount_percent }}%</span
									>
								</div>
								<div class="col p-0">
									<span class="discount-text">
										Discount / <br />
										Unit
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	props: {
		config: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		// Displaying Promo Section under the fold or not
		promo() {
			return this.config.products.packages.find((x) => x.promo === true)
		},
	},
}
</script>

<style lang="scss" scoped></style>
